module.exports = __webpack_public_path__ + "static/media/ENCONTRO_9_ED_FISICA.cec873ba.pdf";